import * as React from "react";
import { cn } from "@/lib/cn";

export interface EmptyStateProps extends Omit<React.HTMLAttributes<HTMLDivElement>, "title"> {
  icon?: React.ReactNode;
  title: React.ReactNode;
  description?: React.ReactNode;
  /** Primary call-to-action that teaches the next step. Required for `hero`. */
  action?: React.ReactNode;
  variant?: "compact" | "hero";
}

export const EmptyState = React.forwardRef<HTMLDivElement, EmptyStateProps>(
  ({ icon, title, description, action, variant = "compact", className, ...props }, ref) => {
    const hero = variant === "hero";
    return (
      <div
        ref={ref}
        className={cn(
          "flex flex-col items-center justify-center text-center gap-3",
          hero ? "py-16" : "py-10",
          className,
        )}
        {...props}
      >
        {icon && (
          <span className={cn("text-muted-foreground", hero ? "text-3xl" : "text-2xl")} aria-hidden="true">
            {icon}
          </span>
        )}
        <div className="flex flex-col gap-1">
          <h3
            className={cn(
              "font-display font-semibold tracking-tight",
              hero ? "text-2xl" : "text-lg",
            )}
          >
            {title}
          </h3>
          {description && (
            <p className="text-sm text-muted-foreground max-w-prose">{description}</p>
          )}
        </div>
        {action && <div className="mt-2">{action}</div>}
      </div>
    );
  },
);
EmptyState.displayName = "EmptyState";
